import { render, staticRenderFns } from "./ExplorerHeader.vue?vue&type=template&id=64dc7f9c&scoped=true"
import script from "./ExplorerHeader.vue?vue&type=script&lang=ts"
export * from "./ExplorerHeader.vue?vue&type=script&lang=ts"
import style0 from "./ExplorerHeader.vue?vue&type=style&index=0&id=64dc7f9c&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64dc7f9c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('64dc7f9c')) {
      api.createRecord('64dc7f9c', component.options)
    } else {
      api.reload('64dc7f9c', component.options)
    }
    module.hot.accept("./ExplorerHeader.vue?vue&type=template&id=64dc7f9c&scoped=true", function () {
      api.rerender('64dc7f9c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Explorer/ExplorerHeader.vue"
export default component.exports